export type Bonus = {
  number: number
  name: string
  description: string
  benefit: string
  value: string
  mockup: string
  imagePosition: string
}

export type Testimonial = {
  name: string
  location: string
  quote: string
  verified?: boolean
}

export type FAQ = {
  question: string
  answer: string
}

export const salesPageData = {
  brand: 'NOVA STUDIO',
  website: '[DOMINIO]',
  supportEmail: 'digitalebooks33@gmail.com',
  productName: 'The Calm Mind Kit',
  productType: 'Ebook práctico en PDF',
  promise: 'Menos caos. Más claridad. Más calma. Desde hoy.',
  headline: 'Organizá tu mente, tus hábitos y tu dinero sin complicarte.',
  subtitle:
    'Un sistema práctico en formato PDF para mujeres que quieren salir del piloto automático, ordenar sus prioridades y recuperar tranquilidad en su día a día.',
  audience: 'Mujeres que buscan una vida más organizada y equilibrada.',
  mainMockup:
    'https://cdn.magicpatterns.com/uploads/kzedcp6BbcUN4ugTsZPuGv/ChatGPT_Image_30_jun_2026,_23_09_24.png',
  checkoutUrl:
    'https://inza4f-uk.myshopify.com/cart/54229370929518:1?channel=buy_button',
  regularPrice: '$39.990 ARS',
  promotionalPrice: '$19.990 ARS',
  savings: '50% de descuento',
  currency: 'ARS',
  guaranteeDays: '7',
  delivery: 'Acceso inmediato luego de confirmar el pago.',
  paymentMethods: 'Mercado Pago · tarjeta de crédito o débito',
  bonusesMockup:
    'https://cdn.magicpatterns.com/uploads/qdYe7w7XU9scxTbxCKNPS2/ChatGPT_Image_14_jul_2026,_21_36_34.png',
  bonuses: [
    {
      number: 1,
      name: 'Planner Diario',
      description:
        'Organizá cada día con tus prioridades, hábitos y objetivos.',
      benefit: 'Empezá el día sabiendo qué importa.',
      value: '$2.500',
      mockup: '[ADJUNTAR MOCKUP DEL BONO 1]',
      imagePosition: '0% 0%',
    },
    {
      number: 2,
      name: 'Organizador Semanal',
      description: 'Planificá toda tu semana de forma visual y simple.',
      benefit: 'Visualizá tu semana sin sentirte abrumada.',
      value: '$2.500',
      mockup: '[ADJUNTAR MOCKUP DEL BONO 2]',
      imagePosition: '50% 0%',
    },
    {
      number: 3,
      name: 'Tracker de Hábitos',
      description: 'Seguí tus avances y mantené la constancia.',
      benefit: 'Convertí pequeños pasos en una rutina posible.',
      value: '$2.500',
      mockup: '[ADJUNTAR MOCKUP DEL BONO 3]',
      imagePosition: '100% 0%',
    },
    {
      number: 4,
      name: 'Mini Planner Financiero',
      description:
        'Una herramienta sencilla para organizar ingresos, gastos y metas de ahorro.',
      benefit: 'Tomá decisiones con más claridad sobre tu dinero.',
      value: '$2.500',
      mockup: '[ADJUNTAR MOCKUP DEL BONO 4]',
      imagePosition: '0% 100%',
    },
    {
      number: 5,
      name: 'Journal Guiado',
      description:
        'Preguntas de reflexión para conectar con tus objetivos y registrar tu progreso.',
      benefit: 'Hacé una pausa para volver a lo importante.',
      value: '$2.500',
      mockup: '[ADJUNTAR MOCKUP DEL BONO 5]',
      imagePosition: '50% 100%',
    },
    {
      number: 6,
      name: 'Checklist de Reinicio Mensual',
      description:
        'Una guía práctica para comenzar cada mes con mayor claridad y organización.',
      benefit: 'Reordená tu mes desde una mirada más serena.',
      value: '$2.500',
      mockup: '[ADJUNTAR MOCKUP DEL BONO 6]',
      imagePosition: '100% 100%',
    },
  ] as Bonus[],
  modules: [
    {
      number: '01',
      title: 'El Método CALM',
      text: 'Aprendé a identificar qué está generando la sobrecarga mental y cómo liberar espacio en tu cabeza para enfocarte en lo importante.',
    },
    {
      number: '02',
      title: 'La regla de las 3 prioridades',
      text: 'Descubrí cómo dejar de correr detrás de las urgencias y empezar a tomar decisiones con intención.',
    },
    {
      number: '03',
      title: 'Organizá tu dinero sin complicarte',
      text: 'Aprendé una forma práctica de ordenar tus gastos, definir objetivos y tomar mejores decisiones financieras.',
    },
    {
      number: '04',
      title: 'Hábitos pequeños, cambios grandes',
      text: 'Pequeños hábitos diarios, mantenidos con constancia, pueden transformar tu vida con el paso del tiempo.',
    },
    {
      number: '05',
      title: 'Diseñá una rutina simple',
      text: 'Creá una rutina flexible que se adapte a tu vida y no al revés.',
    },
  ],
  painPoints: [
    'Vivís con la cabeza llena de pendientes.',
    'Te cuesta mantener hábitos.',
    'Empezás agendas que abandonás a los pocos días.',
    'Sentís culpa cuando no llegás a todo.',
    'Querés organizar mejor tu dinero pero no sabés por dónde empezar.',
    'Saltás de una tarea a otra sin terminar ninguna.',
    'Terminás el día agotada mentalmente.',
    'Sentís que necesitás bajar un cambio pero no sabés cómo.',
  ],
  testimonials: [
    {
      name: 'Carla M.',
      location: 'Buenos Aires',
      quote:
        'Siempre intentaba organizarme con distintas aplicaciones y agendas, pero terminaba abandonándolas. Este kit me ayudó a simplificar mi rutina y a enfocarme en lo que realmente importa. Hoy siento mucha más claridad y menos estrés.',
      verified: true,
    },
    {
      name: 'Florencia G.',
      location: 'Córdoba',
      quote:
        'Lo que más me gustó fue que no es solo un ebook. Los planners, el tracker de hábitos y el mini planner financiero hacen que todo sea mucho más fácil de aplicar. Es práctico, visual y realmente útil.',
      verified: true,
    },
    {
      name: 'Lucía R.',
      location: 'Rosario',
      quote:
        'Buscaba una herramienta para ordenar mi vida sin sentirme abrumada y encontré exactamente eso. El contenido es claro, fácil de seguir y los ejercicios me ayudaron a crear hábitos que pude mantener con el tiempo.',
      verified: true,
    },
  ] as Testimonial[],
  faq: [
    {
      question: '¿Cómo recibo el producto?',
      answer:
        'Una vez confirmado el pago, recibirás el acceso de forma inmediata.',
    },
    {
      question: '¿Es un producto físico?',
      answer: 'No. Es un producto 100% digital en formato PDF.',
    },
    {
      question: '¿Desde qué dispositivos puedo verlo?',
      answer: 'Desde celular, computadora o tablet.',
    },
    {
      question: '¿Los bonos están incluidos?',
      answer: 'Sí. Los seis bonos forman parte de la compra.',
    },
    {
      question: '¿Cómo pago?',
      answer:
        'A través de Mercado Pago con tarjeta de crédito o débito, utilizando los medios habilitados por la plataforma.',
    },
    {
      question: '¿Tiene garantía?',
      answer: 'Sí. Contás con una garantía de 7 días.',
    },
    {
      question: '¿Para quién es este kit?',
      answer:
        'Está diseñado especialmente para mujeres que buscan una vida más organizada y equilibrada.',
    },
    {
      question: '¿Puedo descargar el material?',
      answer: '[AGREGAR INFORMACIÓN REAL SOBRE LA DESCARGA]',
    },
    {
      question: '¿Incluye actualizaciones?',
      answer: '[AGREGAR INFORMACIÓN REAL SOBRE ACTUALIZACIONES]',
    },
  ] as FAQ[],
  urgency: {
    endDate: 'Hoy accedés con 50% de descuento.',
    availability: 'Ebook completo + 6 bonos descargables.',
    condition: 'Recibilo inmediatamente después de tu compra.',
  },
  upsell: {
    enabled: false,
    name: '[NOMBRE DEL UPSELL]',
    description: '[DESCRIPCIÓN]',
    benefit: '[BENEFICIO PRINCIPAL]',
    regularPrice: '[PRECIO REGULAR]',
    promotionalPrice: '[PRECIO PROMOCIONAL]',
    mockup: '[ADJUNTAR MOCKUP]',
    url: '[LINK]',
  },
}
